/**
 * The full Pactline CLM logo. Its wordmark is dark ink, so the Dark theme
 * (the `.dark` class) swaps in the white-wordmark version.
 */
export function BrandLogo({ className = "", alt = "Pactline CLM" }: { className?: string; alt?: string }) {
  return (
    <>
      <img src="/pactline.png" alt={alt} className={`${className} dark:hidden`} />
      <img src="/pactline-dark.png" alt={alt} className={`${className} hidden dark:block`} />
    </>
  );
}
